export default (funnelList:string):string => `
-- Here are the funnels the user has created so far and that is currently showing in the dashboard --
    
${funnelList}

If the user asks anything about any of these funnels, answer to the best of your ability.  If you're unable to derive the answer from this list, prompt the user to open the funnel, and then ask the question again.  Render your response using markdown.

If you render the name of any funnel, use the funnel's name as a link to the funnel.  For example, if the funnel's name is "My First Funnel" with an id of "123", you should render it as [My First Funnel](/funnels/123).
`;